import { useState } from 'react';
import moment from 'moment';
import { DateTimeStamp } from '../../../types/primitives/DateTimeStamp';
import { LenderCallPopup } from './LenderCallPopup';

interface LenderCallLinkProps {
    issuer: string;
    lenderCallDate: DateTimeStamp;
    liveDomestic?: string;
    liveInternational?: string;
    livePasscode?: string;
    replayDomestic?: string;
    replayInternational?: string;
    replayPasscode?: string;
}

export function LenderCallLink({
    issuer,
    lenderCallDate,
    liveDomestic,
    liveInternational,
    livePasscode,
    replayDomestic,
    replayInternational,
    replayPasscode,
}: LenderCallLinkProps) {
    const [visible, setVisible] = useState(false);
    const displayDate = moment.parseZone(lenderCallDate).format('ddd, MMM D, YYYY, h:mm A');

    return (
        <>
            <button className="pseudo-link text-ellipsis" onClick={() => setVisible(true)}>{displayDate}</button>
            {visible && (
                <LenderCallPopup
                    issuer={issuer}
                    lenderCallDate={lenderCallDate}
                    liveDomestic={liveDomestic}
                    liveInternational={liveInternational}
                    livePasscode={livePasscode}
                    replayDomestic={replayDomestic}
                    replayInternational={replayInternational}
                    replayPasscode={replayPasscode}
                    onClose={() => setVisible(false)}
                />
            )}
        </>
    );
}
